import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { DialPadButtonBase } from 'features/dial-pad/styles';
import {
  selectIsDialPadCollapsed,
  toggleDialPad,
  toggleDialPadCollapse,
} from 'features/dial-pad/store';
import theme from 'features/theme/theme';

export const OpenDialpadButton: FC = () => {
  const { t } = useTranslation('translation');
  const dispatch = useAppDispatch();
  const isCollapsed = useAppSelector(selectIsDialPadCollapsed);

  const handleOpenDialpad = () => {
    // Ensure dialpad opens in collapsed state
    if (!isCollapsed) {
      dispatch(toggleDialPadCollapse());
    }
    dispatch(toggleDialPad());
  };

  return (
    <OpenButton
      onClick={handleOpenDialpad}
      data-testid='open-dialpad-button'
      $width={`calc(100% - ${theme.spacing(8)})`}
      $margin={theme.spacing(4)}
    >
      {t('dialPad.openDialpad')}
    </OpenButton>
  );
};

const OpenButton = DialPadButtonBase;
